const table_simple = {
	group: "block",
	content: "tableCell_simple*",
};

const tableHeaderRow_simple = {
	group: "block",
	content: "tableHeader_simple+",
};

const tableBodyRow_simple = {
	group: "block",
	content: "tableCell_simple+",
};

const tableHeader_simple = {
	group: "block",
	content: "inline+",
};

const tableCell_simple = {
	group: "block",
	content: "inline+",
};

export { table_simple, tableHeaderRow_simple, tableBodyRow_simple, tableHeader_simple, tableCell_simple };
